import Link from '@components/Link';
import Price from '@components/Price';
import PriceList from '@components/PriceList';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { memo } from 'react';
import { useSelector } from 'react-redux';

import { Root, HasError, Error } from './ChoosePlan.module.css';

const ChoosePlan = ({
  selected,
  onChange,
  onBlur,
  className,
  subscriptions,
  popular,
  changeMembership,
  error,
  location,
  name: inputName,
  isLoading,
  ...props
}) => {
  const { t } = useTranslation(['checkout', 'account', 'common']);
  const { isSingle, isBusiness } = useSelector((state) => state.checkout);
  const classes = classNames(
    Root,
    {
      [HasError]: error,
    },
    className
  );

  const errorElement = error && (
    <div role="alert" className={Error}>
      {error.message}{' '}
      <Link
        className={Error}
        href="/hjaelp/medlemskab/ny-kunde#hvor-kan-man-ikke-faa-all-inclusive-henne"
        target="_blank"
      >
        {t('readMoreHere', { ns: 'checkout' })}
      </Link>
    </div>
  );

  const isInBodø = location.name === 'Bodø - Sætlandshaugen';

  return (
    <>
      <PriceList
        className={classes}
        changeSelectionText={t('changeMembership', { ns: 'account' })}
        onClick={(index) => {
          onChange(subscriptions[index].id);
          onBlur(subscriptions[index]);
        }}
        items={subscriptions.map(
          ({
            id,
            name,
            price,
            description,
            is_popular: isPopular,
            notMonthly = false,
          }) => ({
            name: isSingle ? t('singleWash', { ns: 'common' }) : name,
            description:
              isInBodø && name !== 'Express'
                ? 'Inkl. børsteløs, berøringsfri bilvask'
                : description,
            label: isPopular ? <>{t('popular', { ns: 'common' })}</> : null,
            right: (
              <>
                <Price amount={price} showDecimals={isBusiness} />
                {!notMonthly ? t('perMonth', { ns: 'common' }) : null}
              </>
            ),
            className: `pricelist-plan-${id}`,
          })
        )}
        selectedIsBigText
        {...props}
        selected={
          selected
            ? (() => {
                const index = subscriptions.findIndex(
                  ({ id }) => id === selected
                );
                return index !== -1 ? index : 2; // Default to 2 if not found
              })()
            : subscriptions.length + 1
        }
      />
      {errorElement}
    </>
  );
};

ChoosePlan.defaultProps = {
  onChange: () => {},
};

export default memo(
  ChoosePlan,
  (prevProps, nextProps) =>
    prevProps.subscriptions === nextProps.subscriptions &&
    prevProps.selected === nextProps.selected &&
    prevProps.error === nextProps.error &&
    prevProps.isLoading === nextProps.isLoading
);
